export const SET_LOADING_DATA = '@rewards/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@rewards/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@rewards/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@rewards/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@rewards/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@rewards/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@rewards/SAVE_REQUEST';
export const SAVE_SUCCESS = '@rewards/SAVE_SUCCESS';

export const DELETE_ITEM = '@rewards/DELETE_ITEM';
export const EDIT_ITEM = '@rewards/EDIT_ITEM';

export const SEARCH = '@rewards/SEARCH';

export const SET_PAGE = '@rewards/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@rewards/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@rewards/SET_ORDER';
export const SET_ORDERBY = '@rewards/SET_ORDEBY';
